module.exports = __webpack_public_path__ + "img/press-08.80e1bdc1.jpeg";